export default __webpack_public_path__ + "static/media/image.evensel.c7713565.png";